export enum CommonTypes {
  CATEGORIA_RESQUEST = '@common/CATEGORIA_RESQUEST',
  CATEGORIA_SUCCESS = '@common/CATEGORIA_SUCCESS',
  CATEGORIA_FAILURE = '@common/CATEGORIA_FAILURE',
}

export interface CommonState {
  readonly categoria: any;
  readonly loading: boolean;
  readonly error: boolean;
}
